import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BidOutlook, ListItem, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './outlook.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class OutlookComponent extends RepositoryModal<BidOutlook> {
    competitorsList: ListItem<number>[] = []
    boolList: ListItem<boolean>[] = [new ListItem(true, 'Yes'), new ListItem(false, 'No')]

    protected onInitialized() {
        const competitors = this.editOptions.initializeParams.allCompetitors || []
        const competitorsList = competitors.map(c => new ListItem(c.id, c.name))
        competitorsList.forEach(c => {
            if (this.target.competitorIds.includes(c.value)) {
                c.selected = true
            }
        })
        this.competitorsList = competitorsList
    }

    protected onBeforeSave(): boolean {
        this.target.competitorIds = this.competitorsList.filter(c => c.selected).map(c => c.value)
        return true
    }
}
